import { StarIcon } from "@src/assets";
import { Skeleton } from "@src/components";
import { AnimatedNumber } from "@src/components/AnimatedNumber";

export type CardInfo = {
  title: string;
  value: number;
  prevValue?: number;
  prefix?: string;
  precision?: number;
};

type Props = {
  cards: { leftCard: CardInfo; rightCard: CardInfo };
  isLoading?: boolean;
};

export const StatsHeader = ({ cards, isLoading }: Props) => {
  const { leftCard, rightCard } = cards;

  return (
    <div className="w-full flex gap-2">
      <div className="flex-1 bg-card_bg p-4 rounded-xl flex flex-col items-center justify-center">
        <p className="font-medium text-sm text-text_primary/60">
          {leftCard.title}
        </p>

        {isLoading ? (
          <Skeleton className="w-12 h-8" />
        ) : (
          <p className="font-bold text-2xl text-text_primary">
            {leftCard.prefix && <span>{leftCard.prefix}</span>}
            <AnimatedNumber
              to={leftCard.value}
              from={leftCard.prevValue}
              precision={leftCard.precision}
            />
          </p>
        )}
      </div>
      <div className="flex-1 bg-card_bg p-4 rounded-xl flex flex-col items-center justify-center">
        <p className="font-medium text-sm text-text_primary/60">
          {rightCard.title}
        </p>
        <div className="flex items-center">
          {isLoading ? (
            <Skeleton className="w-12 h-8" />
          ) : (
            <>
              <p className="font-bold text-2xl text-text_primary">
                {rightCard.prefix && <span>{rightCard.prefix}</span>}

                <AnimatedNumber
                  to={rightCard.value}
                  from={rightCard.prevValue}
                  precision={rightCard.precision}
                />
              </p>
              <StarIcon />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
